import React from "react";

export default function Loader() {
  return (
    <div className="wrap-loader">
      <div className="loader"></div>
    </div>
  );
}
